import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface DevUser {
  id: string;
  email: string;
  role: string;
  name: string;
  description: string;
  redirectTo: string;
}

interface DevAuthContextType {
  devUser: DevUser | null;
  setDevUser: (user: DevUser | null) => void;
  isDevMode: boolean;
  setDevMode: (enabled: boolean) => void;
}

const DevAuthContext = createContext<DevAuthContextType | undefined>(undefined);

export function DevAuthProvider({ children }: { children: ReactNode }) {
  const [devUser, setDevUser] = useState<DevUser | null>(null);
  const [isDevMode, setDevMode] = useState(false);

  // Activer le mode dev automatiquement en développement
  useEffect(() => {
    const isDev = import.meta.env.DEV || window.location.hostname === 'localhost';
    setDevMode(isDev);
  }, []);

  return (
    <DevAuthContext.Provider value={{ devUser, setDevUser, isDevMode, setDevMode }}>
      {children}
    </DevAuthContext.Provider>
  );
}

export function useDevAuth() {
  const context = useContext(DevAuthContext);
  if (context === undefined) {
    throw new Error('useDevAuth must be used within a DevAuthProvider');
  }
  return context;
}